import { Component, OnInit } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from '../api.service';
import { AuthService } from '../auth.service';
import { HandlerService } from '../handler.service';
import { LocationService } from '../location.service';
import { ToastService } from '../toast.service';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss'],
})
export class AdminComponent  {
  assess1:boolean;
  loader:boolean = false;
  id;
  constructor(public service: ApiService,
    public handler: HandlerService,
    public router: Router,
    public translate: TranslateService,
    public location: LocationService,
    public toast: ToastService,
    public bottomSheet: MatBottomSheet,
    public auth:AuthService) {}

    ionViewWillEnter(){
      sessionStorage.setItem('vendorApp','true');
    }

    orgProfile(){
      this.id = localStorage.getItem('organizationId')
      this.router.navigate(['org-profile/',this.id])  
    }

}
